var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useReport, formatReportModuleParams } from '@tencent/dz-report';
export var useReportSerivce = function (_a) {
    var hospital = _a.hospital, config = _a.config;
    var report = useReport();
    var reportParams = {
        module_id: hospital.hospitalId,
        module_value: hospital.name,
        module_type: 'top_hospital',
        module_chinese_type: '顶部医院',
        element_id: hospital.hospitalId,
        element_type: 'top_hospital',
        element_chinese_type: '顶部医院',
        element_content: hospital.name,
    };
    // 向子组件传递的report module参数， 第二个参数可以整理一些额外携带的参数
    var reportModuleParams = formatReportModuleParams(reportParams);
    /**
     * interface ChildrenProps {
     *  reportModuleParams: ReportModuleParams<{
     *    id: string
     *  }>
     * }
     * const Children = (props: reportModuleParams) => {
     *  const { reportModuleParams } = props
     * }
     */
    // 组件曝光逻辑
    React.useEffect(function () {
        // 医院曝光
        report.exposure(reportParams);
        // 医院快速电话曝光
        if (config.quick_tel_enable === 1) {
            report.exposure(__assign(__assign({}, reportParams), { element_id: config.quick_tel_component_id, element_type: 'phone', element_chinese_type: '电话组件' }));
        }
    }, []);
    var hospitalModalExposure = function () {
        report.exposure(reportParams);
    };
    var hospitalClick = function () {
        report.click(reportParams);
    };
    return {
        hospitalModalExposure: hospitalModalExposure,
        hospitalClick: hospitalClick,
        reportModuleParams: reportModuleParams,
    };
};
